import { Injectable } from "@angular/core";
import { firstValueFrom, Observable, Subscription, take } from "rxjs";
import { CitronellaActionsAPIService } from "../API/CitronellaActionsAPI.service";
import { CitronellaExternalAPIService } from "../External API/CitronellaExternalAPI.service";
import { ImageCacheService } from "../ImageCache.service";
import { CitronellaImgDataResponse } from "../../models/ExternalAPI/CitronellaImgDataResponse";
import { AuthService } from "src/app/features/pages/authmanagement/services/Auth.service";
import { CustomersService } from "./Customers.service";
import { SessionService } from "../Session.service";
import { ThirdPartySettingsService } from "./ThirdPartySettings.service";
import { LocalStorageService } from "../LocalStorage.service";
import { LocationDTO } from "src/app/features/map-features/sections/locations-section/models/LocationDTO";

@Injectable({
  providedIn: "root",
})
export class CitronellaActionsService {
  datosUserIdDummy = "e7a1b5c5-751d-4623-bc7d-60c01114d0cd";
  identifierDummy = "ODTUNLV53-1145";
  categoryDummy = 6;

  isLoadingUrlSettings: boolean = false;

  Subscription_getVirtualLocationImages: Subscription;
  Subscription_getImagesUrlSetting: Subscription;

  constructor(
    private citronellaActionsService: CitronellaActionsAPIService,
    private citronellaExternalAPIService: CitronellaExternalAPIService,
    private imageCacheService: ImageCacheService,
    private authService: AuthService,
    private sessionService: SessionService,
    private thirdPartySettingsService: ThirdPartySettingsService,
    private localStorageService: LocalStorageService,
  ) {}

  async verifyCitronellaImagesUrl() {
    if (!this.citronellaExternalAPIService.isUrlSettingComplete() && !this.isLoadingUrlSettings) {
      try {
        this.isLoadingUrlSettings = true;
        const urlSettings = await firstValueFrom(this.thirdPartySettingsService.getCitronellaImagesSettings().pipe(take(1)));
        if (urlSettings.result != null && urlSettings.result.url != null && urlSettings.result.path != null && urlSettings.result.token != null) {
          this.citronellaExternalAPIService.setUrlSettings(urlSettings.result.url, urlSettings.result.path, urlSettings.result.token);
        }
        this.isLoadingUrlSettings = false;
      } catch (error) {
        this.isLoadingUrlSettings = false;
      }
    }
  }

  async GetExternalImages(idCategory: number, identifier: string): Promise<string[]> {
    //esta linea solo evita que se haga la búsqueda fuera de unilever. quitar después de pedir third party settings dinámicos
    if (this.sessionService.Customer == null || !this.sessionService.Customer.referer.includes("unilever"))
      return [];

    await this.verifyCitronellaImagesUrl();
    if (!this.citronellaExternalAPIService.isUrlSettingComplete())
      return [];

    var hasImages = this.imageCacheService.hasCitronellaImageByIdentifier(identifier);
    if (!hasImages) {
      //se usa dummy de idUser de adminUnilever para revisar imagenes con todos los perfiles, sustituir después de hacer pruebas 
      // const userId = this.datosUserIdDummy;
      const userId = this.authService.getUserId();

      const response: any = await this.citronellaExternalAPIService.getVirtualLocationImagesFetch(idCategory, identifier, userId);
      if (response.Data != null && response.Data.length > 0) {
        const images: CitronellaImgDataResponse[] = response.Data;
        for (const citronellaImgData of images) {
          await this.imageCacheService.setCitronellaImageBase64(citronellaImgData, identifier);
        }
        setTimeout(() => {
          this.imageCacheService.emptyCitronellaImagesByIdentifier(identifier);
        }, 5 * 60 * 1000);
        const result = this.imageCacheService.getCitronellaImagesByIdentifier(identifier);
        return result;
      }else{
        return [];
      }
      
      // if (this.Subscription_getVirtualLocationImages)
      //   this.Subscription_getVirtualLocationImages.unsubscribe();
      // this.Subscription_getVirtualLocationImages = this.citronellaExternalAPIService.getVirtualLocationImages(idCategory, identifier, this.datosUserIdDummy).subscribe((response) => {
      //   if(!environment.production) console.log("GetExternalImages response:", response);
      //   if (!!response.data && response.data.length > 0) {
      //     const images: CitronellaImgDataResponse[] = response.data;
      //     images.forEach((citronellaImgData: CitronellaImgDataResponse) => {
      //       this.imageCacheService.setCitronellaImageBase64(citronellaImgData, identifier);
      //     });
      //     return this.imageCacheService.getCitronellaImagesByIdentifier(identifier);
      //   }
      // });
    } else {
      return this.imageCacheService.getCitronellaImagesByIdentifier(identifier);
    }
  }


  getVirtualLocationImages(VirtualCategoryId: number, VirtualIdentifier: string, MapixUserId: string): Observable<any> {
    return this.citronellaExternalAPIService.getVirtualLocationImages( VirtualCategoryId, VirtualIdentifier, MapixUserId );
  }

  /* createWorkflowLockGPS(identifier: string) {
    if (this.LastDataGeoPosition != null) {
      var body = {
        CustomerId: this.LastDataGeoPosition.clientId,
        WorkFlowId: this.TypeActionGPSButton,
        POCFullName: this.LastDataGeoPosition.description.replace("-", " "),
        ProjectDescription: "Bloqueo / Desbloqueo GPS",
        POCPhoneNumber: "5512345678",
        POCMobileNumber: "5512345678",
        POCEmail: this.localStorageService.getUser(),
        SerialNumber: this.SerieGPS,
        LocationId: this.LastDataGeoPosition.id,
        PostalCodeId: this.LastDataGeoPosition.postalCodeId,
      };
      if(!environment.production) console.log(body);

      this.createWorkflowPost(body)
        .pipe(first())
        .subscribe((rest) => {
          if(!environment.production) console.log("Bloqueo", rest);

          if (rest.isSuccess == true) {
            this.changeStatusGPSPost(identifier, "EN PROCESO");
            this.notifyService.showSuccess(
              "Acción realizada correctamente",
              ""
            );
          }
        });
    }
  } */

  createBlokingRequest(identifier: string) {
    return this.citronellaActionsService.createBlokingRequest(identifier);
  }

  getBlokingState(identifier: string): Observable<any> {
    return this.citronellaActionsService.getBlokingState(identifier);
  }

  getLocationImages(identifier: string) {
    return this.citronellaActionsService.getLocationImages(identifier);
  }

  createProspectTicketRequest(location: LocationDTO, userMail: string) {
    return this.citronellaActionsService.createProspectTicketRequest(location, userMail);
  }

}
